import styled, { css } from 'styled-components'

const ArgosFooter = styled.footer`
  overflow: hidden;

  ${(props) =>
    css`
      ${props.type === 'default'
        ? css`
            border-top: 2px solid ${props.theme.color_grey_darker};
          `
        : css`
            padding-top: 15px;
            text-align: center;
            border-top: 1px solid ${props.theme.color_grey_light_mid};
          `}
    `}
`
// PRIMARY SECTION
const Primary = styled.div`
  background: ${(props) => props.theme.color_white};
  padding: 30px 0 0;

  button {
    margin-bottom: 15px;
  }

  @media only screen and (min-width: ${(props) => props.theme.screen_md_min}) {
    background: ${(props) => props.theme.color_grey_darker};
    padding: 15px 0 30px;
  }
`

const PrimaryTitle = styled.h4`
  color: ${(props) => props.theme.color_white};
  margin: 15px 0;
`

const PrimaryLink = styled.a`
  padding: 3px 0;
  display: block;
  color: ${(props) => props.theme.color_white};
  text-decoration: none;

  &:hover,
  &:active {
    text-decoration: underline;
    color: ${(props) => props.theme.color_white};
  }
`

// BRAND SECTION
const Brand = styled.div`
  text-align: center;
  padding: 30px 10px;
  border-bottom: 2px solid ${(props) => props.theme.color_grey_darker};
`

const BrandImage = styled.a`
  ${(props) =>
    css`
    ${props.tu &&
      css`
        img {
          height: 20px;
          margin: 0 50px 0 30px;
        }
      `}
    ${props.sainsburys &&
      css`
        img {
          height: 38px;
          margin: 0 0 -18px 25px;
        }
      `}
    ${props.habitat &&
      css`
        img {
          width: 90px;
        }
      `}
    `}
`

// SERVICE SECTION
const Service = styled.div`
  text-align: center;
  padding: 15px 0 0;

  @media only screen and (min-width: ${(props) => props.theme.screen_md_min}) {
    padding: 30px 0 15px;
  }

  picture {
    width: 48px;
    height: 32px;
    padding: 2px;
  }
`

const ServiceBlock = styled.div`
  margin-bottom: 30px;

  @media only screen and (min-width: ${(props) => props.theme.screen_md_min}) {
    margin-bottom: 15px;
  }
`

// SOCIAL APP SECTION
const SocialApp = styled.div`
  background: ${(props) => props.theme.color_grey_darker};
  padding: 0 0 30px;
  text-align: center;
`

const SocialAppTitle = styled.strong`
  color: ${(props) => props.theme.color_white};
  width: 100%;
  display: block;
  padding: 30px 0 15px;
`

const SocialAppLink = styled.a`
  border: 2px solid ${(props) => props.theme.color_white};
  display: inline-block;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  padding-top: 8px;
  vertical-align: top;

  &:nth-child(2) {
    img {
      width: 21px;
    }
  }

  &:nth-child(3) {
    margin: 0 15px;
    img {
      height: 25px;
    }
  }

  &:nth-child(4) {
    img {
      width: 24px;
      margin-top: 2px;
    }
  }
`

const SocialAppLinkBottom = styled.a`
  ${(props) =>
    css`
      ${props.google &&
        css`
          display: flex;
          justify-content: flex-start;
          img {
            width: 134px;
            height: 38px;
            text-align: left;
          }
        `}
      ${props.apple &&
        css`
          display: flex;
          justify-content: flex-end;
          img {
            width: 134px;
            height: 38px;
            text-align: right;
          }
        `}
    `}
`

// LEGAL SECTION
const Legal = styled.div`
  padding: 30px 15px;
  text-align: center;

  ${(props) =>
    css`
      ${props.variant === 'default'
        ? css`
            color: ${props.theme.color_white};
            background: #000;
            a {
              text-decoration: none;
              color: ${props.theme.color_white};
            }
          `
        : css`
            color: ${props.theme.color_grey_darker};
            background: ${props.theme.color_white};
            a,
            button {
              text-decoration: underline;
              color: ${props.theme.color_tertiary};

              &:hover,
              &:active {
                color: ${props.theme.color_tertiary_dark};
              }
            }
          `}
    `}
`

const LegalLink = styled.a`
  padding: 3px 5px;
  display: inline-block;
  border: inherit;
  background: none;
  font: inherit;

  &:hover,
  &:active {
    text-decoration: underline;
    color: ${(props) => props.theme.color_white};
  }
`

const CheckoutFooter = styled.div`
  justify-content: center;
`

const CheckoutFooterRow = styled.div`
  width: 100%;
`

const CheckoutLogos = styled.div`
  picture {
    display: inline-block;
    max-height: 40px;
    margin: 0 5px;
    max-width: 16%;
  }
`

const CreditCopy = styled.div`
  margin-top: 20px;
`

export {
  ArgosFooter,
  Primary,
  PrimaryLink,
  PrimaryTitle,
  Brand,
  BrandImage,
  SocialApp,
  SocialAppTitle,
  SocialAppLink,
  SocialAppLinkBottom,
  Service,
  ServiceBlock,
  Legal,
  LegalLink,
  CheckoutFooter,
  CheckoutFooterRow,
  CheckoutLogos,
  CreditCopy
}
